import React from "react";
import { Button } from "antd";
import styles from "./footer.scss";

function Footer({ onSearchClick }) {
  return (
    <React.Fragment>
      <Button onClick={onSearchClick} className={styles.search}>
        {"Pretraži odabranu kategoriju"}
      </Button>
    </React.Fragment>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel2/SubLevel2Desktop/Footer/index.tsx